import axiosInstance from "../lib/axiosInstance";

class vendorpincodeModel {

    constructor() {
        this.base_url = "/vendor_pincodes"
    }
  
    async create(data = []) {
        return await axiosInstance.post(`${this.base_url}/import`, data);
    }
    


}

export default new vendorpincodeModel();